export function track(category, action, label, value) {
  window.uetq = window.uetq || [];

  const bingData = {};

  if (category) { bingData.ec = category; }
  if (action) { bingData.ea = action; }
  if (label) { bingData.el = label; }
  if (value) { bingData.ev = value; }

  return window.uetq.push(bingData);
}
